module.exports = {
    default: 'default',

    common: {
        event: 'event',
        error: 'error',
    },

    account: {
        login: 'login',
        shopper: 'shopper',
        shopperPreferences: 'shopperPreferences',
        shopperMyAccount: 'shopperMyAccount',
    },

    content: {
        dynamicContent: 'dynamicContent',
        general: 'content',
        inspiration: 'inspiration',
        recipeCategory: 'recipeCategory',
        recipeDetail: 'recipe',
        catalogue: 'catalogue',
    },

    customEvent: {
        bannerClick: 'bannerClick',
        dialogClick: 'dialogClick',
        productClick: 'productClick',
        linkClick: 'linkClick',
        recipeClick: 'recipeClick',
        menuClick: 'menuClick',
        customEvent: 'customEvent',
        trolley: {
            addTo: 'trolleyAddTo',
            addAllTo: 'trolleyAddAllTo',
            productClick: 'trolleyProductClick',
            productClickAddAllTo: 'trolleyProductClickAddAllTo',
            cartAdd: 'cartAdd',
            cartRemove: 'cartRemove',
            cartBuyOnline: 'cartBuyOnline',
            save: 'trolleySave',
            clear: 'trolleyClear',
        },
        order: {
            cancel: 'orderCancel',
        },
        store: {
            select: 'selectStore',
        },
        account: {
            userRegister: 'userRegister',
            userLogin: 'userLogin',
            accountEdit: 'accountEdit',
        },
        search: {
            success: 'searchSuccess',
        },
        list: {
            Add: 'listAdd',
            AddOrder: 'listAddOrder',
        },
    },

    search: {
        filter: 'filter',
        result: 'result',
    },

    seo: {
        pageTitle: 'pageTitle',
        pageInfo: 'pageInfo',
        metaData: 'pageMetadata',
    },

    shop: {
        checkout: 'checkout',
        checkoutPackagingPreference: 'checkoutPackagingPreference',
        checkoutSteps: 'checkoutSteps',
        fulfilment: 'fulfilment',
        fulfilmentSelector: {
            fulfilmentSelectorDialog: 'fulfilmentSelectorDialog',
        },
        onBoardingDialog: 'onBoardingDialog',
        order: 'orderAnalytics',
        productCategory: 'productCategory',
        productdetail: 'productdetail',
        promoCode: 'promoCode',
        trolley: 'trolley',
        cart: 'cart',
        orderConfirmation: 'orderConfirmation',
        myList: 'myList',
        userPreference: 'userPreference',
        stockChecker: 'stockChecker',
    },

    store: {
        tripPlanner: 'tripPlanner',
        search: 'storeLocator',
        detail: 'storeDetail',
        productDetail: 'storeProductDetail',
    },

    deliveryPlus: 'deliveryPlus',
};



// WEBPACK FOOTER //
// ./src/analytics/mapper-types.constants.js